import Campaigns from '@/pages/Campaigns.vue';
import Changelogs from '@/pages/Changelogs.vue';
import CreateFeed from '@/pages/CreateFeed';
import FeedId from '@/pages/feed/FeedId';
import Feeds from '@/pages/Feeds';
import Login from '@/pages/Login';
import NotFound from '@/pages/NotFound';
import Statistics from '@/pages/Statistics';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: 'feeds',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Авторизация',
    },
  },
  {
    path: '/create-feed/',
    name: 'create-feed',
    component: CreateFeed,
    meta: {
      title: 'Создание фида',
      auth: true,
    },
  },
  {
    path: '/feeds/',
    name: 'feeds',
    component: Feeds,
    meta: {
      title: 'Фиды',
      auth: true,
    },

  },
  {
    path: '/stats/',
    name: 'stats',
    component: Statistics,
    meta: {
      title: 'Статистика',
      auth: true,
    },
  },
  {
    path: '/campaigns/',
    name: 'campaigns',
    component: Campaigns,
    meta: {
      title: 'Кампании',
      auth: true,
    },
  },
  {
    path: '/changelogs',
    name: 'changelogs',
    component: Changelogs,
    meta: {
      title: 'Логи',
      auth: true,
    },
  },
  {
    path: '/feed/:id',
    name: 'FeedId',
    component: FeedId,
    meta: {
      title: 'Редактирование фида',
      auth: true,
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const hasToken = Vue.$auth.hasToken();
  if (to.name === 'NotFound') {
    if (hasToken) {
      next();
    } else {
      next({ name: 'login' });
    }
  } else {
    if (to.meta.auth && !hasToken) {
      next({ name: 'login' });
    } else {
      next();
    }
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || '';
  });
});

export default router;
